import React, { useState } from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {Dropdown1} from '../../content/dropdown/Dropdown1'
import useFetch from 'app/hooks/useFetch'


type Props = {
  className: string
}

const ListsWidget2: React.FC<Props> = ({className}) => {
const [loading, setLoad] = useState<boolean>()
  // fetch amd_getContratos
  const { data: contactos, refetch: getDataGrid } = useFetch('amd_getContactos', { setLoading: setLoad })

  const b64toBlob = (b64Data: any, contentType: any ='', sliceSize: any =512) => {
    const byteCharacters = atob(b64Data)
    const byteArrays = []
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)
  
      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }
  
      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }
  
    const blob = new Blob(byteArrays, {type: contentType})
    return blob
  }

  const getLink = (dataLink: any) => {
    let tipo: string = dataLink.avatar_tipo.replaceAll('*1', '/').replaceAll('*2', '.').replaceAll('*3', ',').replaceAll('*4', ';').replaceAll('*5', ':')
    const blob: any = b64toBlob(dataLink.avatar, tipo)
    const blobUrl: any = URL.createObjectURL(blob)

    return blobUrl
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0'>
        <h3 className='card-title fw-bolder text-dark'>Contactos</h3>
        <div className='card-toolbar'>
          {/* begin::Menu */}
          <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
          </button>
          <Dropdown1 />
        </div>
      </div>
      {/* end::Header */}

      <div className='card-body pt-2'>
      {/*  <div className='d-flex align-items-center mb-7'>
          <div className='symbol symbol-50px me-5'>
            <img src={toAbsoluteUrl('/media/avatars/300-1.jpg')} className='' alt='' />
          </div>
          <div className='flex-grow-1'>
            <a href='#' className='text-dark fw-bolder text-hover-primary fs-6'>
              Ivan Araya
            </a>
            <span className='text-muted d-block fw-bold'>ivan.araya@goplicity.com</span>
            <span className='text-muted d-block fw-bold'>+569 619 171 77</span>
          </div>
        </div> */}

        { !!contactos &&
          contactos.map((e: any, index: number) =>
            <div key={index}>
              <div className='d-flex align-items-center mb-7'>
                <div className='symbol symbol-50px me-5'>
                  <img src={getLink(e)} className='' alt='' />
                </div>
                <div className='flex-grow-1'>
                  <a href='#' className='text-dark fw-bolder text-hover-primary fs-6'>
                    {e.nombre}
                  </a>
                  <span className='text-muted d-block fw-bold'>{e.email}</span>
                  <span className='text-muted d-block fw-bold'>{e.telefono}</span>
                </div>
              </div>
            </div>
          )
        }
      </div>
      {/* end::Body */}
    </div>
  )
}

export {ListsWidget2}
